import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import * as userActions from '../../actions/usersActions';
import moment from 'moment';
// import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import { toastr } from 'react-redux-toastr';
// import * as SVGICONS from '../../images/img/images';
import * as appointmentActions from '../../actions/appointmentActions';
// import CreditCardInput from 'react-credit-card-input';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as specialistActions from '../../actions/specialistActions';
import getSymbolFromCurrency from 'currency-symbol-map'
import InputMask from 'react-input-mask';
// import Moment from 'react-moment';
class Payment extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = { value: '' };
        this.state = {
            patternOne: false,
            stripeLoading: true,
            stripeLoadingError: false,
            submitDisabled: false,
            paymentError: null,
            paymentComplete: false,
            token: null,
            card: 0,
            expiry: 0,
            cvc: 0,
            spinner: false,
            countryList: [],
            cardNumber: null,
            ispayment: false,
            appointmentDetails: {},
            ammountToPay: '',
            nameOnCard: '',
            postalCode: "",
            country: '',
        }
        this.confirmAppointment = this.confirmAppointment.bind(this);
        this.onChange = this.onChange.bind(this);
        this.expiryDate = this.expiryDate.bind(this);

    }

    componentWillMount() {
        this.props.specialistActions.getCountriesList();
        let appointmentObj = {
            appointmentId: localStorage.getItem('appointmentId'),
            omitCommission: localStorage.getItem('clinicCountryZone') == moment.tz.guess()
        }
        console.log("appointmentObj", appointmentObj)
        this.props.appointmentActions.getAppointmentDetails(appointmentObj);
    }

    componentWillReceiveProps(nextProps) {
        let currancy = nextProps.convertedCurrency ? parseFloat(nextProps.convertedCurrency.result).toFixed(2) : '';
        console.log("============>", nextProps, currancy)
        if (currancy) {
            this.setState({
                ammountToPay: currancy
            })
        }
        if (nextProps.paymentDetails.success == false) {
            this.setState({
                spinner: false
            })
        }
        else if (nextProps.paymentDetails && this.state.ispayment) {
            this.props.history.push('/dashboard/booking-confirmation');
            this.setState({ ispayment: false })
        }
        if (nextProps.countryList != undefined) {
            this.setState({
                countryList: nextProps.countryList,
            })

        }
        if (nextProps.appointmentDetails) {
            this.setState({
                appointmentDetails: nextProps.appointmentDetails

            })
            if (nextProps.appointmentDetails.DoccurrencySymbol != null && nextProps.appointmentDetails.DoccurrencySymbol != "" && isNaN(this.state.ammountToPay)) {
                let data = {
                    base: nextProps.appointmentDetails.DoccurrencySymbol,
                    amount: nextProps.appointmentDetails.totalfee
                }

                this.props.specialistActions.currencychange(data);
            }

        }
    }

    componentDidMount() {
    }

    onChange(event) {

        this.setState({
            [event.target.name]: event.target.value
        })

    }
    expiryDate(event) {
        if (event.target.name == 'expiry') {
            if (event.target.value.length > 7) {
                event.target.value = this.state.expiry

            }
            else {
                this.setState({
                    [event.target.name]: event.target.value
                })
            }
        }
    }
    confirmAppointment(event) {



        event.preventDefault();
        localStorage.removeItem('availabilityId');
        localStorage.removeItem('slot');
        localStorage.removeItem('ReservedDate');
        localStorage.removeItem('ReservedSlot');
        localStorage.removeItem('ReservedDoctorName');
        localStorage.removeItem('ReservedAvailability');
        let state = this.state;
        if (state.card.length > 0 && state.expiry.length > 0 && state.cvc.length > 0 || state.card == null || state.expiry == null || state.cvc == null) {

            var Cardnumber = this.state.card.replace(/-/g, "");
            let userlocation = moment.tz.guess()
            var card = {
                "number": Cardnumber,
                "exp_month": this.state.expiry.split('/')[0],
                "exp_year": this.state.expiry.split('/')[1],
                "cvc": this.state.cvc,
                "nameOnCard": this.state.nameOnCard,
                "postalCode": this.state.postalCode,
                "country": this.state.country
            }
            this.setState({
                spinner: true,
                ispayment: true
            })
            // let settingsObj={
            // 	staffID:this.props.appointmentDetails._id
            // }
            // console.log("==>>", userlocation)
            // return 
            var patientId = localStorage.getItem('userId')
            this.props.appointmentActions.makepayment({ 'carddetails': card, userlocation ,  'patientId': patientId, 'appointmentId': localStorage.getItem('appointmentId') });
        } else {
            toast.error('Insert proper card details')

            // this.props.actions.getAppointmentsForMonth(settingsObj);
            // this.props.actions.getAppointmentsForDay(settingsObj);
        }
    }

    render() {
        const countryList = this.state.countryList.map(function (data, index) {
            return (<option key={index} data={index} value={data._id} >{data.name}</option>)
        });
        return (
            <div className="content-wrapper">
                <section className="content container-fluid">
                    {/* <ToastContainer /> */}

                    <div className="row">
                        <div className="col-md-12">
                            <div className="boxMrgB">
                                <div className="nav-tabs-custom">
                                    <ul className="nav nav-tabs">
                                        <li className="active"><Link href="#tab_1" data-toggle="tab" className="active show">Appointment Payment</Link></li>
                                        <li className=" col-md">
                                            <div className="content-header"><ol className="breadcrumb">
                                                <li><Link> Book Appointment</Link></li>
                                                <li><Link to="/book-appointment">Search Specialist</Link></li>
                                                <li><Link to="/book-appointment-calendar">Appointment Details</Link></li>
                                                <li className="active">Appointment Payment</li>
                                            </ol></div>

                                        </li>
                                    </ul>
                                    <div className="tab-content">
                                        <div className="row">
                                            <div className="col-md-6 logo-payment">

                                                <img src={require('../../images/logo.svg')} alt="Medfix Logo" />

                                                <div className="power-privacy"> <p className="Textcolor">Powered by <span className='stripeColor'><b>Stripe</b> </span> <span className='midlinestripe'>| </span><span> <Link>Terms</Link> <Link>Privacy</Link></span></p></div>
                                            </div>
                                            <div className="col-md-6">

                                                <form className="appointmentDetaile-form customPaymentPage" id="appointmentDetaileForm">

                                                    <div className="tab-pane active" id="tab_1">
                                                        <div className="settingInput appointmentBox">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <h3>Pay with card</h3>
                                                                    <div className="col-md-5 column-nameinput">
                                                                        <div className="boxMrgB">

                                                                            {/* <div className="input-group inputBg"> <span className="input-group-addon"><i className="fa ">		<img src={require('../../images/img/user_input_icon.svg')} alt="" /></i></span>
																	<input type="text" name="card" id='card'  onChange={this.onChange.bind(this)} className="form-control text-capitalize" placeholder="Card number" />
																</div> */}
                                                                            {/* <div className="input-group inputBg"> <span className="input-group-addon"><i className="fa ">		<img src={require('../../images/img/user_input_icon.svg')} alt="" /></i></span>
																	<input type="text" name="expiry" id='expiry'  onChange={this.onChange.bind(this)} className="form-control text-capitalize" placeholder="MM/YY" />
																</div> */}
                                                                            {/* <div className="input-group inputBg"> <span className="input-group-addon"><i className="fa ">		<img src={require('../../images/img/user_input_icon.svg')} alt="" /></i></span>
																	<input type="text" name="cvc" id='cvc'  onChange={this.onChange.bind(this)} className="form-control text-capitalize" placeholder="CVC" />
																</div> */}
                                                                            <span className="help-block"></span>
                                                                        </div>
                                                                    </div>
                                                                    <div >
                                                                        <label>
                                                                            card Information
                                </label>
                                                                        <div className="input-group inputBg cardImgs cardNumberBorder">

                                                                            {/*    <input type="text"  onChange={this.onChange} className="form-control text-capitalize" placeholder="1234 1234 1234 1234 "

                                id="card"
                                name="card"
                                required

                                />
*/}


                                                                            <InputMask
                                                                                className="form-control text-capitalize"
                                                                                placeholder="Card Number"
                                                                                id="card"
                                                                                name="card"
                                                                                required
                                                                                mask="9999-9999-9999-9999"
                                                                                //     value={this.state.CardNumberView}
                                                                                key={1}
                                                                                required="required"
                                                                                onChange={this.onChange}
                                                                                data-parsley-errors-messages-disabled={this.state.errorCard}

                                                                            // data-parsley-pattern={reg.usPhoneValidation}
                                                                            />
                                                                            <img src={require('../../images/Group5.png')} alt='visa' />
                                                                            <img src={require('../../images/mastercard.png')} alt='mastercard' />
                                                                            <img src={require('../../images/american-express.png')} alt='american express' />
                                                                            <img src={require('../../images/Group8.png')} alt='discover' />

                                                                        </div>
                                                                        <div className="input-group inputBg expiryInput expiryBorder">
                                                                            {/* <input type="text"  onChange={this.onChange} className="form-control text-capitalize" placeholder="MM/YY"


																		id="expiry"
																		name="expiry"
																		onKeyUp = {this.expiryDate.bind(this)}
																		required

                              />
                               */}
                                                                            <InputMask
                                                                                onChange={this.onChange}
                                                                                className="form-control text-capitalize"
                                                                                placeholder="MM/YY"
                                                                                id="expiry"
                                                                                name="expiry"
                                                                                onKeyUp={this.expiryDate.bind(this)}
                                                                                required
                                                                                mask="99/9999"
                                                                                key={2}
                                                                            />
                                                                        </div>


                                                                        <div className="input-group inputBg expiryInput cvcBorder">
                                                                            <input onChange={this.onChange} className="form-control text-capitalize" placeholder="CVC"
                                                                                id="cvc"
                                                                                name="cvc"
                                                                                maxLength='3'
                                                                                type="password"
                                                                                required

                                                                            />
                                                                        </div>
                                                                        {/* <CreditCardInput
															// 	containerClassName="custom-container"
															// 	cardCVCInputRenderer={({ handleCardCVCChange, props }) => (

                              //     <div className="paymentCvc">
															// 		<input
															// 			{...props}
															// 			onChange={handleCardCVCChange(e => console.log())}
															// 			onBlur={this.onChange.bind(this)}
															// 			id="cvc"
															// 			name="cvc"
															// 			type="password"
															// 			required
                              //     />
                              //     </div>
															// 	)}
															// 	cardExpiryInputRenderer={({ handleCardExpiryChange, props }) => (
                              //     <div className="paymentExpiry">
															// 		<input
															// 			{...props}
															// 			onChange={handleCardExpiryChange(e =>
															// 				console.log()
															// 			)}
															// 			onBlur={this.onChange.bind(this)}
															// 			id="expiry"
															// 			name="expiry"
															// 			onKeyUp = {this.expiryDate.bind(this)}
															// 			required

                              //     />
                              //     </div>

															// 	)}
															// 	cardNumberInputRenderer={({ handleCardNumberChange, props }) => (
                              //   <div className="PaymentCardNumber">
                              //     <input
															// 			{...props}
															// 			onChange={handleCardNumberChange(e =>
															// 				console.log()
															// 			)}
															// 			onBlur={this.onChange.bind(this)}
															// 			id="card"
															// 			name="card"
															// 			required
                              //     />
                              //     </div>
															// 	)}
                              // />*/}
                                                                    </div>
                                                                    <div className="labelCustom">
                                                                        <label>
                                                                            Name on Card
                              </label>
                                                                        <div className="input-group inputBg border1pxSolid">
                                                                            <input type="text" name="nameOnCard" onChange={this.onChange} className="form-control text-capitalize" placeholder="Enter Name" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="labelCustom">
                                                                        <label>
                                                                            Country or Region
                              </label>
                                                                        <div className="">
                                                                            <div className="input-group inputBg border1pxSolid countryBorder">
                                                                                <select className="form-control" name="country" style={{ border: 0 }} onChange={this.onChange}>
                                                                                    <option>
                                                                                        select Country
                             </option>
                                                                                    {countryList}
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                        <div className="input-group inputBg border1pxSolid postalcodeborder">
                                                                            <input type="text" name="postalCode" onChange={this.onChange} className="form-control text-capitalize" placeholder="Postal Code" />

                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                <div className="col-md-12 text-center">
                                                                    <div className="">
                                                                        <button type="button" className="btn btn-warning btn-lg btncolor" onClick={this.confirmAppointment.bind(this)} disabled={this.state.spinner ? true : false}> Pay
                                        
                                {localStorage.getItem('currency') != 'AED' ? <span>{getSymbolFromCurrency(localStorage.getItem('currency'))} {this.state.ammountToPay}</span> : <span>{this.state.ammountToPay} د.إ}</span>}

                                                                            {this.state.spinner ? <i className="fa fa-spinner fa-spin" /> : ""}</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="Copyrightafterlogin">
                    <p>Medfix &copy; 2018. All rights reserved</p>

                </div>
            </div >
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        appointmentDetails: state.appointment.appointmentDetails,
        paymentDetails: state.appointment.paymentDetails ? state.appointment.paymentDetails : { 'success': false },
        countryList: state.specialist.countryList,
        convertedCurrency: state.specialist.convertedCurrency,



    };
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
        appointmentActions: bindActionCreators(appointmentActions, dispatch),
        specialistActions: bindActionCreators(specialistActions, dispatch),

    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Payment);
